import React from "react";
import PropTypes from "prop-types";
import {Form, Input, Select, DatePicker, Row, Col, Button} from "antd";

import "./GeneralInfoTab.css";
import moment from "moment";
import OriginalIDTypeSelector from "./selector/OriginalIDTypeSelector";
import {getIdType, getIndustryCode, getOccupationCode, getSourceOfFundCode} from "../api/api";
import {displayGenericError} from "../common/notifications";
import BrdgxNationalitySelector from "./selector/BrdgxNationalitySelector";
import {getCountryList, getNationalityList} from "../api/api";
import BrdgxCountrySelector from "./selector/BrdgxCountrySelector";
import OccupationSelector from "./selector/OccupationSelector";
import IndustrySelector from "./selector/IndustrySelector";
import SourceOfFundsSelector from "./selector/SourceOfFundsSelector";
import Modal from "antd/es/modal";
import Divider from "antd/es/divider";
import get from "lodash/get";
import retrieveMyinfoImg from "./images/Primary.png";


class GeneralIndividualInfoTab extends React.Component {
    state = {
        customerAccount: this.props.customerAccount,
        occupations: [],
        nationalities: [],
        idTypes: [],
        industries: [],
        countries: [],
        sourceOfFunds :[],
        visibleNextScreen: false,
        occupation:'',
        industry:''
    };

    constructor(props) {
        super(props);
        this.customer = this.props.customer;
    }

    componentDidMount() {
        getSourceOfFundCode().then(response => {
            this.setState({
                sourceOfFunds: response
            });
        }).catch(error => {
            displayGenericError(error);
        });
        getIndustryCode().then(response => {

            let industry =  this.state.customerAccount.personalAccountDetails.industry;
            if(industry){
                let item = response.filter(s => s.code === industry);
                if(item){
                    industry  = item[0].value;
                }
            }

            this.setState({
                industries: response,
                industry:industry
            });
        }).catch(error => {
            displayGenericError(error);
        });
        getOccupationCode().then(response => {

            let occupation =  this.state.customerAccount.personalAccountDetails.occupation;
            if(occupation){
                let item = response.filter(s => s.code === occupation);
                if(item){
                    occupation  = item[0].value;
                }
            }
            this.setState({
                occupations: response,
                occupation: occupation
            });
        }).catch(error => {
            displayGenericError(error);
        });
        getNationalityList()
            .then(response => {
                this.setState({
                    nationalities: response
                });
            })
            .catch(error => {
                displayGenericError(error);
            });
        getCountryList()
            .then(response => {
                this.setState({
                    countries: response
                });
            })
            .catch(error => {
                displayGenericError(error);
            });


        getIdType().then(response => {
            this.setState({
                idTypes: response
            });
        }).catch(error => {
            displayGenericError(error);
        });
    }

    onFormDataChanged = event => {
        const target = event.target;
        const inputName = target.name;
        const inputValue = target.value;
        let personalAccountDetails = Object.assign(this.state.customerAccount.personalAccountDetails, {[inputName]: inputValue});

        this.setState({
            customerAccount: Object.assign(this.state.customerAccount, {personalAccountDetails: personalAccountDetails}),

        }, () => {
            this.props.handleFieldChange(this.state.customerAccount)
        });

    };
    onIndustryChanged  =  (fieldName, newValue) => {

        let item = this.state.industries.filter(s => s.value === newValue);
        let industryCodeValue = newValue;
        if(item){
            industryCodeValue = item[0].code;
        }
        let personalAccountDetails = Object.assign(this.state.customerAccount.personalAccountDetails, {[fieldName]: industryCodeValue});
        this.setState({
            customerAccount: Object.assign(this.state.customerAccount, {personalAccountDetails: personalAccountDetails}),
            industry : newValue

        }, () => {
            this.props.handleFieldChange(this.state.customerAccount)
        });
    }
    onOccupationChanged =  (fieldName, newValue) => {

        let item = this.state.occupations.filter(s => s.value === newValue);
        let occupationCodeValue = newValue;
        if(item){
            occupationCodeValue = item[0].code;
        }
        let personalAccountDetails = Object.assign(this.state.customerAccount.personalAccountDetails, {[fieldName]: occupationCodeValue});
        this.setState({
            customerAccount: Object.assign(this.state.customerAccount, {personalAccountDetails: personalAccountDetails}),
            occupation : newValue

        }, () => {
            this.props.handleFieldChange(this.state.customerAccount)
        });
    }
    onFieldChanged = (fieldName, newValue) => {
        let personalAccountDetails = Object.assign(this.state.customerAccount.personalAccountDetails, {[fieldName]: newValue});

        this.setState({
            customerAccount: Object.assign(this.state.customerAccount, {personalAccountDetails: personalAccountDetails}),

        }, () => {
            this.props.handleFieldChange(this.state.customerAccount)
        });

    };
    handleNextScreen = (customer) => {
        if (customer.companyProfile.baseCurrency !== 'SGD'){
            this.handleSubmit();
        } else {
            this.setState({
                visibleNextScreen: true
            })
        }
    }
    handleSubmit = () => {
        this.props.onSubmit(this.state.customerAccount, false);
        this.setState({
            visibleNextScreen: false
        })
    };

    handleMyinfo = () => {
        this.props.onSubmit(this.state.customerAccount, true);
        this.setState({
            visibleNextScreen: false
        })
    };

    handleCancel = () => {
        this.setState({
            visibleNextScreen: false
        })
    }
    buildOtherValue() {
        let result = false;
        if(this.state.customerAccount.personalAccountDetails && !this.state.customerAccount.personalAccountDetails.sourceOfFunds) {
            return undefined;
        }else {
            for (let sourceItem in this.state.sourceOfFunds) {
                if (this.state.sourceOfFunds[sourceItem].code === this.state.customerAccount.personalAccountDetails.sourceOfFunds) {
                    return '';
                }
            }
        return this.state.customerAccount.personalAccountDetails.sourceOfFunds;
        }
    }
    buildSourceOfFundValue() {
        if (this.state.sourceOfFunds.length == 0) {
            return this.state.customerAccount.personalAccountDetails.sourceOfFunds;
        }
        if (this.state.customerAccount.personalAccountDetails && !this.state.customerAccount.personalAccountDetails.sourceOfFunds) {
            return undefined;
        } else {
            for (let sourceItem in this.state.sourceOfFunds) {
                if (this.state.sourceOfFunds[sourceItem].code === this.state.customerAccount.personalAccountDetails.sourceOfFunds) {
                    return this.state.customerAccount.personalAccountDetails.sourceOfFunds;
                }
            }
            return "OTHERS";
        }
    }

    render() {
        const accountStatus = get(this.props.customerAccount, "status", null);
        return (
            <div className="general-info-tab">
                <div className="left-pane">
                    <Row gutter={24}>
                        <Col className="gutter-row" md={12}>
                            <Form.Item
                                label="First Name *">
                                <Input
                                    value={this.state.customerAccount.personalAccountDetails.firstName}
                                    name="firstName"
                                    size={"large"}
                                    disabled={true}
                                    onChange={this.onFormDataChanged}
                                />
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" md={12}>
                            <Form.Item
                                label="Last Name *"
                            >
                                <Input
                                    value={this.state.customerAccount.personalAccountDetails.lastName}
                                    name="lastName"
                                    size={"large"}
                                    disabled={true}
                                    onChange={this.onFormDataChanged}
                                />
                            </Form.Item>
                        </Col>

                    </Row>

                    <Row gutter={24}>
                        <Col className="gutter-row" md={12}>
                            <Form.Item
                                label="Contact Number *">
                                <Input
                                    value={this.state.customerAccount.personalAccountDetails.contactNumber}
                                    name="contactNumber"
                                    size={"large"}
                                    autoComplete="none"
                                    onChange={this.onFormDataChanged}
                                    disabled={true}
                                />
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" md={12}>
                            <Form.Item
                                label="Source Of Wealth *"
                                required="true">
                                <SourceOfFundsSelector
                                    size={"large"}
                                    sourceOfFunds = {this.state.sourceOfFunds}
                                    placeholder="Select Source Of Wealth"
                                    otherValue={this.buildOtherValue()}
                                    value={this.buildSourceOfFundValue()}
                                    onChange={(newValue, otherValue) => {
                                        if (otherValue) {
                                            this.onFieldChanged("sourceOfFunds", otherValue)
                                        } else {
                                            this.setState({
                                                otherValue:''
                                            })
                                            this.onFieldChanged("sourceOfFunds", newValue)
                                        }
                                    }
                                    }
                                />
                            </Form.Item>
                        </Col>
                        

                    </Row>
                    <Row gutter={24}>
                        <Col className="gutter-row" md={12}>
                            <Form.Item
                                label="Occupation *">
                                <OccupationSelector style={{width: '100%'}}   size={"large"}
                                                    occupations={this.state.occupations}
                                                    placeholder="Select Occupation *"
                                                    value={this.state.occupation}
                                                    onChange={newValue => this.onOccupationChanged("occupation", newValue)}
                                />
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" md={12}>
                            <Form.Item
                                label="Industry *">
                                <IndustrySelector style={{width: '100%'}}
                                                size={"large"}
                                                industries={this.state.industries}
                                                placeholder="Select Industry *"
                                                value={this.state.industry}
                                                onChange={newValue => this.onIndustryChanged("industry", newValue)}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col className="gutter-row" md={12}>
                            <Form.Item
                                label="Company *">
                                <Input
                                    value={this.state.customerAccount.personalAccountDetails.company}
                                    name="company"
                                    placeholder="Enter company name"
                                    size={"large"}
                                    autoComplete="none"
                                    onChange={this.onFormDataChanged}
                                />
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" md={12}>
                            <Form.Item label="Annual Income *">
                                <Select
                                    name="annualSalary"
                                    value={this.state.customerAccount.personalAccountDetails.annualSalary || undefined}
                                    style={{ width: '100%' }}
                                    size={"large"}
                                    placeholder="Select Annual Income *"
                                    onChange={newValue => this.onFieldChanged("annualSalary", newValue)}>
                                    <Select.Option value="NO_INCOME">No Income</Select.Option>
                                    <Select.Option value="BELOW_50000">Below 50,000 (SGD)</Select.Option>
                                    <Select.Option value="50000-100000">50,000-100,000 (SGD)</Select.Option>
                                    <Select.Option value="100000-200000">100,000-200,000 (SGD)</Select.Option>
                                    <Select.Option value="200000-500000">200,000-500,000 (SGD)</Select.Option>
                                    <Select.Option value="ABOVE_500000">Above 500,000 (SGD)</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                       
                    </Row>
                    <Row gutter={24}>
                        <Col className="gutter-row" md={24}>
                            <div className="button-wrapper">
                                <Button className="bt-skip" onClick={this.props.redirectMain}>
                                    Back
                                </Button>
                                <Button
                                    className="bt-next"
                                    type="primary"
                                    onClick={this.handleNextScreen.bind(this, this.props.customer)}>
                                    Next
                                </Button>
                                
                            </div>
                        </Col>
                    </Row>
                   
                </div>
                <Modal
                    visible={this.state.visibleNextScreen}
                    title=" "
                    onCancel={this.handleCancel}
                    footer={[
                        <Row gutter={[10, 10]}>
                            <Col><Button block key="myinfo" className="bt-myinfo"  disabled={!accountStatus ||  accountStatus === 'PENDING'} onClick={this.handleMyinfo}>
                                <img src={retrieveMyinfoImg} alt="Retrieve MyInfo with singpass" className="bt-myinfo-img"/>
                            </Button></Col></Row>,
                        <Row gutter={[10, 10]}>
                            <Col>
                                <Button block key="submit" type="primary" className="bt-input-manual" onClick={this.handleSubmit}>
                                    Input personal info manually
                                </Button></Col></Row>,
                        <Row gutter={[10, 10]}><Col><Button type="dashed" block key="cancel" className="bt-input-cancel"
                                                            onClick={this.handleCancel}>
                            Cancel
                        </Button></Col></Row>,
                    ]}
                >
                </Modal>
            </div>
        );
    }

}

GeneralIndividualInfoTab.propTypes = {
    nextTab: PropTypes.func
};

export default GeneralIndividualInfoTab;
